module.exports = __webpack_public_path__ + "img/alex_journey.46ec2f29.svg";